import React from 'react';
import PropTypes from 'prop-types';

const LocallyRecommended = ({ fill, gradientFill1, gradientFill2, id }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.68 22.41">
    <defs>
      <linearGradient id={`grad-${id}`} x1="0%" y1="0%" x2="100%" y2="0%">
        <stop
          offset="0%"
          style={{
            stopColor: gradientFill1,
            stopOpacity: 1,
          }}
        />
        <stop
          offset="100%"
          style={{
            stopColor: gradientFill2,
            stopOpacity: 1,
          }}
        />
      </linearGradient>
    </defs>
    <g>
      <g>
        <path
          fill={gradientFill1 && gradientFill2 ? `url(#grad-${id})` : fill}
          d="M15.62,19.38l-2.93-6.85.1,0,.31-.15.53-1.85,1.09-1.28.19-.28-.46-1.87.31-1.65,0-.34L13.44,3.69l-.55-1.58-.16-.3-1.85-.54L9.61.19,9.33,0,7.45.46,5.81.15l-.34,0L4.08,1.46,2.5,2l-.3.15L1.66,4,.57,5.3l-.19.28L.84,7.45.54,9.09l0,.34,1.34,1.4.56,1.58.15.3.3.09L.05,19.38a.7.7,0,0,0,.65,1H.82l2.87-.52L5,22.06a.71.71,0,0,0,.61.35h0a.68.68,0,0,0,.6-.42l1.61-3.75L9.44,22a.7.7,0,0,0,.6.42h0a.71.71,0,0,0,.61-.35L12,19.82l2.87.52H15a.7.7,0,0,0,.64-1Zm-12.86-9L1.56,9.08l.28-1.53,0-.15-.4-1.61,1-1.18.09-.12L3,2.89l1.45-.51.15,0,1.2-1.16,1.53.29h.15l1.61-.39,1.18,1,.12.09L12,2.64l.52,1.47.06.14,1.15,1.19L13.45,7l0,.15.4,1.62-1,1.18-.09.12-.45,1.54,0,.06-1.45.51-.14.06-.43.41-.59.56-.17.16,0,0-.9-.17-.63-.12H7.78l-.69.17-.91.22,0,0L6,13.27l-1-.84,0,0-.1-.07-.22-.06-.43-.13-1-.27v0Zm.84,8.42-2.41.43,2.64-6.18.58.17,1.15,1ZM5.55,21l-1-1.8,1.88-4.38L7.29,17Zm4.57,0L8.38,17,7.84,15.7,7.2,14.22l.64-.16.65.12.55.11.24.56h0l1.88,4.38Zm2-2.21-2-4.68,1.14-1.09.54-.19,2.73,6.39Z"
        />
      </g>
    </g>
  </svg>
);

LocallyRecommended.propTypes = {
  fill: PropTypes.string,
  gradientFill1: PropTypes.string,
  gradientFill2: PropTypes.string,
  id: PropTypes.number,
};

LocallyRecommended.defaultProps = {
  fill: null,
  gradientFill1: null,
  gradientFill2: null,
  id: 0,
};

export default LocallyRecommended;
